import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Self-host fonts to eliminate external requests (Latin subset only for better performance)
import "@fontsource/outfit/latin-300.css"
import "@fontsource/outfit/latin-400.css"
import "@fontsource/outfit/latin-600.css"
import "@fontsource/outfit/latin-800.css"
import "@fontsource/jetbrains-mono/latin-400.css"
import "@fontsource/jetbrains-mono/latin-700.css"

import './index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
